export enum CurrencyEnum {
  SEK = 'SEK',
  EUR = 'EUR',
}
